import {connect} from 'react-redux'
import {compose} from "redux";
import ForgotPassword from "./ForgotPassword";
import {getLoadingEntity} from "../../../redux/selectors/ui/ui.selectors";
import {FORGOT_PASSWORD, postForgotPassword} from "../../../redux/actions/app/password/password.actions";

const mapStateToProps = state => {
    return {
        loading: getLoadingEntity(state, FORGOT_PASSWORD),
    }
}

const mapDispatchToProps = {
    postForgotPassword
}

const ForgotPasswordContainer = compose(
    connect(mapStateToProps, mapDispatchToProps)
)(ForgotPassword)

export default ForgotPasswordContainer
